import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import EditableConfigurationName from "../../../Common/components/EndPage/EditableConfigurationName/EditableConfigurationName";
import CorrespondingCountry from "../../../Retrofit/components/CorrespondingCountry/CorrespondingCountry";
import ActionLinks from "../../../Common/components/EndPage/ActionLinks/ActionLinks";
import ActionSharing from "../../../Common/components/EndPage/ActionSharing/ActionSharing";
import Documentation from "../../../Common/components/EndPage/Documentation/Documentation";
import ConfigurationSaved from "../../../Common/components/EndPage/ConfigurationSaved/ConfigurationSaved";
import { resetMc12, setMc12CurrentStep, selectMc12Configuration, selectMc12Steps } from "../../store/slices/mc12";
import t from "../../../Common/utils/translation/translator";
import BillOfMaterials from "../../../Mc12/components/BillOfMaterials/BillOfMaterials";
import { gatherMc12ProductsForBOM } from "../../../Mc12/utils/func.utils";
import { selectEventsData, setFullScreen, updateConfiguration } from "../../../Common/store/slices/common";
import { logEvent } from "../../../Common/utils/api/api";

const Finalize = ({ ...props }) => {
  const dispatch = useDispatch();
  const steps = useSelector(selectMc12Steps);
  const configuration = useSelector(selectMc12Configuration);
  const products = gatherMc12ProductsForBOM(configuration.configData.track);
  const eventsData = useSelector(selectEventsData);

  useEffect(() => {
    logEvent(eventsData.locale, eventsData.types.save, eventsData.tags.none, configuration?.configId);
  }, [eventsData]);

  const handlePrevious = () => {
    dispatch(setMc12CurrentStep(steps.ACCESSORIES));
    dispatch(updateConfiguration());
  };

  return (
    <>
      <div className="flex flex-row gap-5" {...props}>
        <div className="flex flex-col w-2/3">
          <div className="flex justify-between">
            <EditableConfigurationName />
            {/* Here need to retrieve country from config data */}
            <CorrespondingCountry
              country={configuration.configData.country === "GB" ? "UK" : configuration.configData.country}
            />
          </div>
          <BillOfMaterials productsList={products} />
        </div>
        <div className="flex flex-col gap-5  w-1/3">
          <ConfigurationSaved data-testid="configuration-saved" />
          <div className="flex flex-col gap-4">
            <ActionSharing data-testid="action-sharing" />
            <ActionLinks />
            <Documentation referenceIds={products.map((product) => product.commercialReference)} />
          </div>
        </div>
      </div>
      <Navigator
        data-testid="navigator"
        continueLabel={t("msizer.ui.footer.go_to_start_page")}
        continueAction={() => {
          dispatch(resetMc12());
          dispatch(setFullScreen(false));
        }}
        continueButtonStandard="true"
        previousAction={() => {
          handlePrevious();
        }}
      />
    </>
  );
};
export default Finalize;
